exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.location-map[data-v-1e796820] {\n  width: 100%;\n  height: 80vh;\n}\n", ""]);

// exports
